import { unset } from 'lodash';
import api from '@/services/Api';
import {getField, updateField} from 'vuex-map-fields';

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

// signup contract form
const defaultSignupFormState = () => {
    return {
        step: 0,
        company_data: {
            sfa: null,
            tax_id: null,
            name: null,
            city: null,
            street: null,
            street_no: null,
            zip_code: null,
            payer_office: false, // checkbox
            payer_office_number: {
                sfa: null,
                keg: null,
                bottle: null
            }
        },
        brand: null,
        area: null,
        contractor_data: {
            first_name: null,
            last_name: null,
            email: null,
            phone_number: null,
            birthday: null,
            sign: null
        },
        sales_representative_data: {
            first_name: null,
            last_name: null,
            sign: null
        },
        agreements: {} // dynamic
    }
}
// signup activation form
const defaultSignupActivationFormState = () => {
    return {
        step: 0,
        activation: null,
        contractor_data: {
            id: null,
            first_name: null,
            last_name: null,
            sign: null
        },
        company_data: {}, // bind from api /details
        sales_representative_data: {
            first_name: null,
            last_name: null,
            sign: null
        },
        agreements: {} // dynamic
    }
}

const state = {
    errors: [],
    loading: false,
    //
    brands: [],
    currentBrandName: 'Tyskie',
    rules: [],
    results: [],
    activations: [],
    //
    filterResultsForm: {
        // sfa: localStorage.getItem('default_sfa') ? localStorage.getItem('default_sfa') : null,
        sfa: null, // hide for now
        year: new Date().getFullYear()
    },
    // signup contract
    signupForm: defaultSignupFormState(),
    signupToken: null,
    signupUuid: null,
    signupFile: null,
    // signup activation
    signupActivationForm: defaultSignupActivationFormState(),
    signupActivationUuid: null,
    //
    activation_single: {},
};

// ----------------------------- o

const getters = {
    getField, // mapFields helper
};

// ----------------------------- o

const actions = {
    'LOYALTY_BRANDS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/brands';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('LOYALTY_BRANDS_SUCCESS', resp.data.data);
                    resolve(resp);
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_RULES_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/rules';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('LOYALTY_RULES_SUCCESS', resp.data.data);
                    resolve(resp);
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_RESULTS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let params = payload
            let url = 'loyalty-program/v3/results';
            api({url: url, params: params ? params : null, method: 'GET'})
                .then(resp => {
                    commit('LOYALTY_RESULTS_SUCCESS', resp.data.results);
                    resolve(resp);
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_ACTIVATIONS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/activations';
            api({url: url, params: payload ? payload : null, method: 'GET'})
                .then(resp => {
                    commit('LOYALTY_ACTIVATIONS_SUCCESS', resp.data.activations);
                    resolve(resp);
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_ACTIVATIONS_SINGLE_REQUEST': ({commit, dispatch}, slug) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/activations/' + slug + '/details';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('LOYALTY_ACTIVATIONS_SINGLE_SUCCESS', resp.data.activation);
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_STORE_REQUEST': ({commit, dispatch}, next_step) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/contracts/create';
            let data = state.signupForm;
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    commit('LOYALTY_SET_SIGNUP_CURRENT_STEP', next_step);
                    // save uuid if present in response
                    if(resp.data.data.contractUuid){
                        commit('LOYALTY_SET_SIGNUP_UUID', resp.data.data.contractUuid)
                    }
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_CONFIRM_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/contracts/'+payload.uuid+'/confirm';
            let data = {
                sms_token: payload.sms_token
            }
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    commit('LOYALTY_SET_SIGNUP_CURRENT_STEP', 5);
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_CONFIRM_REPEAT_REQUEST': ({commit, dispatch}, uuid) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/contracts/'+uuid+'/confirmation/repeat';
            api({url: url, method: 'GET'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    commit('LOYALTY_SUCCESS');
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_FILE_REQUEST': ({commit, dispatch}, uuid) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/contracts/'+uuid+'/download';
            api({url: url, method: 'GET'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    commit('LOYALTY_SET_SIGNUP_FILE', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_TERMINATE_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/contracts/'+payload.uuid+'/cancel';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    commit('LOYALTY_SUCCESS');
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_VOUCHER_STATUS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'users/ph/'+ payload.ph_slug +'/clients/'+ payload.client_slug +'/details/vouchers/update'
            api({url: url, data: payload, method: 'POST'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    commit('LOYALTY_SUCCESS');
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_CONTRACT_ACTIVATION_STORE_REQUEST': ({commit, dispatch}, next_step) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/activations/create';
            let data = state.signupActivationForm;
            api({url: url, data: data, method: 'POST'})
                .then(resp => {
                    commit('LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP', next_step)
                    // save uuid if present in response
                    if(resp.data.uuid){
                        commit('LOYALTY_SET_ACTIVATION_SIGNUP_UUID', resp.data.uuid)
                    }
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'LOYALTY_ACTIVATION_FILE_REQUEST': ({commit, dispatch}, uuid) => {
        return new Promise((resolve, reject) => {
            commit('LOYALTY_REQUEST');
            let url = 'loyalty-program/v3/activations/'+uuid+'/download';
            api({url: url, method: 'GET'})
                .then(resp => {
                    if(resp.data.message) dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    resolve(resp)
                })
                .catch(err => {
                    commit('LOYALTY_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    }
}

// ----------------------------- o

const mutations = {
    'LOYALTY_REQUEST': (state) => {
        state.errors = {}
        state.loading = true
    },
    'LOYALTY_SUCCESS': (state) => {
        state.errors = {}
        state.loading = false
    },
    'LOYALTY_ERROR': (state, resp) => {
        state.errors = resp
        state.loading = false
    },
    'LOYALTY_BRANDS_SUCCESS': (state, resp) => {
        state.brands = resp
        state.loading = false
    },
    'LOYALTY_RULES_SUCCESS': (state, resp) => {
        state.rules = resp
        state.loading = false
    },
    'LOYALTY_RESULTS_SUCCESS': (state, resp) => {
        state.results = resp
        state.loading = false
    },
    'LOYALTY_ACTIVATIONS_SUCCESS': (state, resp) => {
        state.activations = resp
        state.loading = false
    },
    'LOYALTY_ACTIVATIONS_SINGLE_SUCCESS': (state, resp) => {
        state.activation_single = resp
        state.loading = false
    },
    'LOYALTY_SET_SIGNUP_CURRENT_STEP': (state, index) => {
        state.signupForm.step = index
        // ... and scroll to top
        let el = document.querySelector('.main-wrapper')
        el.scrollTo(0, 0);
    },
    'LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP': (state, index) => {
        state.signupActivationForm.step = index
        // ... and scroll to top
        let el = document.querySelector('.main-wrapper')
        el.scrollTo(0, 0);
    },
    'LOYALTY_SET_SIGNUP_COMPANY_DATA': (state, obj) => {
        state.signupForm.company_data = obj
    },
    'LOYALTY_SET_SIGNUP_ACTIVATION_COMPANY_DATA': (state, obj) => {
        state.signupActivationForm.company_data = obj
        // ... and remove unused object
        _.unset(state.signupActivationForm.company_data, 'payer_office_number')
    },
    'LOYALTY_SET_SIGNUP_UUID': (state, uuid) => {
        state.signupUuid = uuid
    },
    'LOYALTY_SET_ACTIVATION_SIGNUP_UUID': (state, uuid) => {
        state.signupActivationUuid = uuid
    },
    'LOYALTY_SET_SIGNUP_FILE': (state, resp) => {
        state.signupFile = resp
        state.loading = false
    },
    'LOYALTY_RESET_SIGNUP': (state, sfa) => {
        state.signupForm = defaultSignupFormState()
        state.signupForm.step = 0
        // save sfa if is set
        if(sfa) state.signupForm.company_data.sfa = sfa
    },
    'LOYALTY_RESET_ACTIVATION_SIGNUP': (state, sfa) => {
        state.signupActivationForm = defaultSignupActivationFormState()
        state.signupActivationForm.step = 0
    },
    'LOYALTY_REMOVE_AGREEMENT': (state, key) => {
        _.unset(state.signupForm.agreements, key) // working
    },
    'LOYALTY_REMOVE_ACTIVATION_AGREEMENT': (state, key) => {
        _.unset(state.signupActivationForm.agreements, key) // working
    },
    'LOYALTY_SET_SALES_PROFILE': (state, profile) => {
        // signup contract form
        state.signupForm.sales_representative_data.first_name = profile.first_name
        state.signupForm.sales_representative_data.last_name = profile.last_name
        // signup activation form
        state.signupActivationForm.sales_representative_data.first_name = profile.first_name
        state.signupActivationForm.sales_representative_data.last_name = profile.last_name
    },
    'LOYALTY_SET_CONTRACTOR_PROFILE': (state, profile) => {
        state.signupActivationForm.contractor_data.id = profile.id
        state.signupActivationForm.contractor_data.first_name = profile.first_name
        state.signupActivationForm.contractor_data.last_name = profile.last_name
        // ... and remove unused object
        _.unset(state.signupActivationForm.company_data, 'userSigningContract')
    },
    'LOYALTY_SET_CURRENT_BRAND_NAME': (state, name) => {
        state.currentBrandName = name
    },
    updateField, // mapFields helper
}

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}